/*
 * Utilities for manipulating or otherwise dealing with assets
 * and asset data.
 */
import filter from 'lodash/filter';
import find from 'lodash/find';
import get from 'lodash/get';
import sortBy from 'lodash/sortBy';

// This regex matches the mp4 URLS that we provide fallback for - for now, we want only
// the low-quality fallbacks, and we don't want to match any old HLS presets.
// Examples:
// Matches: rover_16x9_480p_sd, rover_16x9_240p_sd
// Not Match: rover_16x9_480p_hls, rover_16x9_240p_hls
const mp4FallbackPresetRegex = /_(240|360|480).*(?!hls)/;

/**
 * Retrieve the URL for a single preset from a list of transcodings.
 * @param {Object[]} An array of asset-specific transcodings.
 * @return {string} The M3U8 URL found, if any.
 */
// eslint-disable-next-line import/prefer-default-export
export function m3u8Url(transcodings) {
  const preset = find(transcodings, {
    mapped_preset_name: 'apple_m3u8',
  });
  return get(preset, 'full_url');
}

/**
 * Retrieve the URL of the best available mp4 URL, up to 480p
 * @param {Object[]} transcodings
 */
export function highestResolutionMp4Url(transcodings) {
  const filtered = filter(transcodings, t => t.mapped_preset_name.match(mp4FallbackPresetRegex));
  const sorted = sortBy(filtered, 'mapped_preset_name');
  const best = sorted.pop();

  return get(best, 'full_url', '');
}
